(function () {
  var isSyncing = false;
  var syncPending = false;
  var syncTimer = null;
  var FREE_GIFT_PROP = '_free_gift_tier';

  function getConfig() {
    var node = document.getElementById('free-gift-global-config');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  // /cart/add.js 返回的 { items: [...] } 只含刚加入的商品，不是完整购物车。
  // 完整购物车（/cart.js、/cart/change.js）一定带有 item_count。
  function isFullCartState(cart) {
    return !!(cart && Array.isArray(cart.items) && typeof cart.item_count === 'number');
  }

  function getActiveTiers(config) {
    return (config.tiers || []).filter(function (tier) {
      return tier.items > 0 && tier.label && tier.variantId;
    });
  }

  function isLegitimateGiftLine(item) {
    return !!(item.properties && item.properties[FREE_GIFT_PROP]);
  }

  function isConfiguredGiftVariant(item, config) {
    if (!config || !config.tiers) return false;

    var variantId = Number(item.variant_id);
    return config.tiers.some(function (tier) {
      return tier.variantId && Number(tier.variantId) === variantId;
    });
  }

  function getPaidItemCount(cart, config) {
    return (cart.items || []).reduce(function (sum, item) {
      if (isLegitimateGiftLine(item)) return sum;
      return sum + item.quantity;
    }, 0);
  }

  function findLegitimateGiftLines(cart, tier) {
    return (cart.items || []).filter(function (item) {
      return item.properties && String(item.properties[FREE_GIFT_PROP]) === String(tier.tier);
    });
  }

  function findIllegalGiftLines(cart, config) {
    return (cart.items || []).filter(function (item) {
      return isConfiguredGiftVariant(item, config) && !isLegitimateGiftLine(item);
    });
  }

  function pushUniqueLine(list, line) {
    if (!list.some(function (existing) { return existing.key === line.key; })) {
      list.push(line);
    }
  }

  function getSectionsPayload() {
    var sections = [];
    var cartDrawerItems = document.querySelector('cart-drawer-items');

    if (cartDrawerItems && typeof cartDrawerItems.getSectionsToRender === 'function') {
      cartDrawerItems.getSectionsToRender().forEach(function (section) {
        if (section.section && sections.indexOf(section.section) === -1) {
          sections.push(section.section);
        }
      });
    }

    var mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems && mainCartItems.dataset.id && sections.indexOf(mainCartItems.dataset.id) === -1) {
      sections.push(mainCartItems.dataset.id);
    }

    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter && mainCartFooter.dataset.id && sections.indexOf(mainCartFooter.dataset.id) === -1) {
      sections.push(mainCartFooter.dataset.id);
    }

    if (sections.indexOf('cart-icon-bubble') === -1) {
      sections.push('cart-icon-bubble');
    }

    return sections;
  }

  function renderCartSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    var cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.getSectionsToRender === 'function') {
      cartDrawerItems.getSectionsToRender().forEach(function (section) {
        var targetElement = document.getElementById(section.id);
        if (!targetElement || !parsedState.sections[section.section]) return;

        var sectionHtml = cartDrawerItems.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        var replaceTarget = targetElement.querySelector(section.selector) || targetElement;
        replaceTarget.innerHTML = sectionHtml;
      });

      if (typeof parsedState.item_count === 'number') {
        cartDrawerItems.classList.toggle('is-empty', parsedState.item_count === 0);
      }
    }

    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      cartItems.getSectionsToRender().forEach(function (section) {
        var targetElement = document.getElementById(section.id);
        if (!targetElement || !parsedState.sections[section.section]) return;

        var sectionHtml = cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        var replaceTarget = targetElement.querySelector(section.selector) || targetElement;
        replaceTarget.innerHTML = sectionHtml;
      });

      if (typeof parsedState.item_count === 'number') {
        cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
      }
    }

    var cartDrawerWrapper = document.querySelector('cart-drawer');
    if (cartDrawerWrapper && typeof parsedState.item_count === 'number') {
      cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    var cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter && typeof parsedState.item_count === 'number') {
      cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    }
  }

  async function refreshDrawerFromServer() {
    if (!document.querySelector('cart-drawer-items')) return;

    var response = await fetch(window.routes.cart_url + '?section_id=cart-drawer&_=' + Date.now(), {
      cache: 'no-store',
    });
    var html = await response.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');

    ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
      var target = document.querySelector(selector);
      var source = doc.querySelector(selector);
      if (target && source) {
        target.replaceWith(source);
      }
    });
  }

  async function fetchCartState() {
    var response = await fetch(window.routes.cart_url + '.js', { cache: 'no-store' });
    return response.json();
  }

  async function removeCartLines(lines, cart, sections, sectionsUrl) {
    if (!lines.length) return null;

    var lineNumbers = lines
      .map(function (line) {
        var idx = cart.items.findIndex(function (item) {
          return item.key === line.key;
        });
        return idx >= 0 ? idx + 1 : null;
      })
      .filter(function (lineNumber) {
        return lineNumber !== null;
      })
      .sort(function (a, b) {
        return b - a;
      });

    var parsedState = null;

    for (var i = 0; i < lineNumbers.length; i++) {
      var body = {
        line: lineNumbers[i],
        quantity: 0,
      };

      if (i === lineNumbers.length - 1) {
        body.sections = sections;
        body.sections_url = sectionsUrl;
      }

      var response = await fetch(window.routes.cart_change_url, {
        ...fetchConfig(),
        body: JSON.stringify(body),
      });

      var responseText = await response.text();
      parsedState = JSON.parse(responseText);

      if (!response.ok || parsedState.status) {
        throw new Error(parsedState.description || parsedState.message || 'gift_remove_failed');
      }
    }

    return parsedState;
  }

  function buildSyncPlan(cart, config) {
    var tiers = getActiveTiers(config);
    var paidCount = getPaidItemCount(cart, config);
    var toAdd = [];
    var toRemove = [];

    findIllegalGiftLines(cart, config).forEach(function (line) {
      pushUniqueLine(toRemove, line);
    });

    tiers.forEach(function (tier) {
      var giftLines = findLegitimateGiftLines(cart, tier);
      var shouldHave = paidCount >= tier.items;

      if (shouldHave && !giftLines.length) {
        toAdd.push(tier);
      } else if (!shouldHave && giftLines.length) {
        giftLines.forEach(function (line) {
          pushUniqueLine(toRemove, line);
        });
      }
    });

    return { toAdd: toAdd, toRemove: toRemove, paidCount: paidCount };
  }

  async function syncFreeGifts(hintCart) {
    if (isSyncing) {
      syncPending = hintCart || true;
      return;
    }

    var config = getConfig();
    if (!config || !config.enabled) return;

    isSyncing = true;
    var parsedState = null;
    var sections = getSectionsPayload();
    var sectionsUrl = window.location.pathname;
    var mutated = false;

    try {
      var cart = isFullCartState(hintCart) ? hintCart : await fetchCartState();
      var plan = buildSyncPlan(cart, config);

      if (!plan.toAdd.length && !plan.toRemove.length) return;

      if (plan.toRemove.length) {
        parsedState = await removeCartLines(plan.toRemove, cart, sections, sectionsUrl);
        mutated = true;
        cart = isFullCartState(parsedState) ? parsedState : await fetchCartState();
        plan = buildSyncPlan(cart, config);
      }

      if (config.autoAdd === false) {
        plan.toAdd = [];
      }

      if (plan.toAdd.length) {
        var addResponse = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: plan.toAdd.map(function (tier) {
              return {
                id: tier.variantId,
                quantity: 1,
                properties: {
                  _free_gift_tier: String(tier.tier),
                  'Free Gift': tier.label,
                },
              };
            }),
            sections: sections,
            sections_url: sectionsUrl,
          }),
        });

        parsedState = await addResponse.json();
        if (!addResponse.ok || parsedState.status) {
          throw new Error(parsedState.description || parsedState.message || 'gift_add_failed');
        }
        mutated = true;
      }

      if (!mutated) return;

      if (parsedState && parsedState.sections) {
        renderCartSections(parsedState);
      }

      await refreshDrawerFromServer();

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        // 加赠品的 /cart/add.js 响应同样不是完整购物车，需重新拉取
        var latestCart = isFullCartState(parsedState) ? parsedState : await fetchCartState();
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift-sync', cartData: latestCart });
      }
    } catch (error) {
      console.error('Free gift sync failed', error);
    } finally {
      isSyncing = false;
      if (syncPending) {
        var pendingCart = syncPending !== true ? syncPending : null;
        syncPending = false;
        scheduleSync(pendingCart, 80);
      }
    }
  }

  function scheduleSync(hintCart, delay) {
    clearTimeout(syncTimer);
    var wait = typeof delay === 'number' ? delay : hintCart ? 80 : 200;
    syncTimer = setTimeout(function () {
      syncFreeGifts(hintCart);
    }, wait);
  }

  function onCartChanged(event) {
    var detail = event && event.detail ? event.detail : {};
    var source = detail.source || (event && event.source);
    if (source === 'free-gift-sync') return;

    // 加购后需等侧边栏先渲染完，再同步赠品；批量加购（FBT）同样需要更长延迟
    var delay = source === 'product-form' || source === 'fbt-bundle' ? 350 : 80;
    // 仅完整购物车可作为 hint，否则传 null 让 sync 自行拉取 /cart.js
    var hintCart = isFullCartState(detail.cartData) ? detail.cartData : null;
    scheduleSync(hintCart, delay);
  }

  function initSync() {
    scheduleSync(null, 200);

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        onCartChanged({ detail: event });
      });
    }

    document.addEventListener('free-gift:cart-changed', onCartChanged);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSync);
  } else {
    initSync();
  }
})();
